import {
  bp
} from "./chunk-JSGRNWSB.js";

// src/styles/tokens/typography.ts
var TypographyGroup = /* @__PURE__ */ ((TypographyGroup2) => {
  TypographyGroup2["Lightspark"] = "Lightspark";
  TypographyGroup2["LightsparkDocs"] = "LightsparkDocs";
  TypographyGroup2["UmaAuthSdk"] = "UmaAuthSdk";
  TypographyGroup2["UmameDocs"] = "UmameDocs";
  TypographyGroup2["Bridge"] = "Bridge";
  return TypographyGroup2;
})(TypographyGroup || {});
var FONT_FAMILIES = {
  main: "Montserrat",
  code: "Monaco"
};
var LINE_HEIGHTS = {
  ["Lightspark" /* Lightspark */]: {
    "8xl": "72px",
    "7xl": "72px",
    "6xl": "60px",
    "5xl": "44px",
    "4xl": "40px",
    "3xl": "36px",
    "2xs": "14px",
    "2xl": "32px",
    lg: "24px",
    md: "20px",
    sm: "18px",
    xl: "28px",
    xs: "16px"
  },
  ["LightsparkDocs" /* LightsparkDocs */]: {
    "8xl": "72px",
    "7xl": "72px",
    "6xl": "60px",
    "5xl": "44px",
    "4xl": "40px",
    "3xl": "36px",
    "2xs": "14px",
    "2xl": "32px",
    lg: "24px",
    md: "20px",
    sm: "18px",
    xl: "28px",
    xs: "16px"
  },
  ["UmaAuthSdk" /* UmaAuthSdk */]: {
    "8xl": "72px",
    "7xl": "72px",
    "6xl": "72px",
    "5xl": "72px",
    "4xl": "60px",
    "3xl": "44px",
    "2xs": "16px",
    "2xl": "40px",
    lg: "32px",
    md: "28px",
    sm: "24px",
    xl: "36px",
    xs: "20px"
  },
  ["UmameDocs" /* UmameDocs */]: {
    "8xl": "72px",
    "7xl": "72px",
    "6xl": "72px",
    "5xl": "72px",
    "4xl": "60px",
    "3xl": "44px",
    "2xs": "16px",
    "2xl": "40px",
    lg: "32px",
    md: "28px",
    sm: "24px",
    xl: "36px",
    xs: "20px"
  },
  ["Bridge" /* Bridge */]: {
    "8xl": "72px",
    "7xl": "60px",
    "6xl": "44px",
    "5xl": "40px",
    "4xl": "36px",
    "3xl": "32px",
    "2xs": "16px",
    "2xl": "28px",
    lg: "22px",
    md: "20px",
    sm: "18px",
    xl: "24px",
    xs: "16px"
  }
};
var lineHeightKeys = Object.keys(
  LINE_HEIGHTS.Lightspark
);
function getLineHeightFromKey(key, theme) {
  return theme.typography.lineHeights[key];
}
var FONT_WEIGHTS = {
  main: {
    ExtraBold: 800,
    Bold: 700,
    SemiBold: 600,
    Medium: 500
  },
  code: {
    Bold: 700,
    Regular: 400
  }
};
var FONT_SIZE = {
  ["Lightspark" /* Lightspark */]: {
    "2xs": "10px",
    xs: "12px",
    sm: "14px",
    md: "16px",
    lg: "20px",
    xl: "24px",
    "2xl": "28px",
    "3xl": "32px",
    "4xl": "36px",
    "5xl": "48px",
    "6xl": "64px"
  },
  ["LightsparkDocs" /* LightsparkDocs */]: {
    "2xs": "10px",
    xs: "12px",
    sm: "14px",
    md: "16px",
    lg: "20px",
    xl: "24px",
    "2xl": "28px",
    "3xl": "32px",
    "4xl": "36px",
    "5xl": "48px",
    "6xl": "64px"
  },
  ["UmaAuthSdk" /* UmaAuthSdk */]: {
    "2xs": "11px",
    xs: "12px",
    sm: "14px",
    md: "16px",
    lg: "20px",
    xl: "24px",
    "2xl": "28px",
    "3xl": "32px",
    "4xl": "36px",
    "5xl": "48px",
    "6xl": "64px"
  },
  ["UmameDocs" /* UmameDocs */]: {
    "2xs": "11px",
    xs: "12px",
    sm: "14px",
    md: "16px",
    lg: "20px",
    xl: "24px",
    "2xl": "28px",
    "3xl": "32px",
    "4xl": "36px",
    "5xl": "48px",
    "6xl": "64px"
  },
  ["Bridge" /* Bridge */]: {
    "2xs": "11px",
    xs: "12px",
    md: "14px",
    lg: "16px",
    xl: "20px",
    "2xl": "24px",
    "3xl": "28px",
    "4xl": "32px",
    "5xl": "36px",
    "6xl": "48px",
    "7xl": "64px"
  }
};
var LETTER_SPACING = {
  ["Lightspark" /* Lightspark */]: {
    "tight-max": "-4%",
    "tight-high": "-3%",
    "tight-medium": "-2%",
    "tight-low": "-0.5%",
    normal: "0",
    "loose-max": "1.44px"
  },
  ["LightsparkDocs" /* LightsparkDocs */]: {
    "tight-max": "-4%",
    "tight-high": "-3%",
    "tight-medium": "-2%",
    "tight-low": "-0.5%",
    normal: "0",
    "loose-max": "1.44px"
  },
  ["UmaAuthSdk" /* UmaAuthSdk */]: {
    tight: "-.02em",
    normal: "0",
    loose: ".1em"
  },
  ["UmameDocs" /* UmameDocs */]: {
    tight: "-.02em",
    normal: "0",
    loose: ".1em"
  },
  ["Bridge" /* Bridge */]: {
    tight: "-2%",
    normal: "0%"
  }
};
var TEXT_CASE = {
  none: "none",
  uppercase: "uppercase"
};
var TEXT_DECORATION = {
  none: "none"
};
var PARAGRAPH_INDENT = {
  0: "0px"
};
var PARAGRAPH_SPACING = {
  default: "default",
  0: "0",
  16: "16px",
  40: "40px"
};
var TokenSize = {
  Large: "Large",
  Mlarge: "Mlarge",
  Medium: "Medium",
  Schmedium: "Schmedium",
  Small: "Small",
  ExtraSmall: "ExtraSmall"
};
var TypographyType = {
  Display: "Display",
  Headline: "Headline",
  Title: "Title",
  Body: "Body",
  BodyStrong: "Body Strong",
  Label: "Label",
  LabelModerate: "Label Moderate",
  LabelStrong: "Label Strong",
  Overline: "Overline",
  Code: "Code",
  CodeStrong: "Code Strong"
};
function getTypographyTypes(fontFamilies) {
  return {
    ["Lightspark" /* Lightspark */]: {
      Mobile: {
        [TypographyType.Display]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */]["7xl"]}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */]["6xl"]}`,
            letterSpacing: "-2.56px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */]["6xl"]}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */]["5xl"]}`,
            letterSpacing: "-1.92px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */]["5xl"]}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */]["4xl"]}`,
            letterSpacing: "-1.44px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.Headline]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */]["4xl"]}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */]["3xl"]}`,
            letterSpacing: "-.96px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */]["3xl"]}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */]["2xl"]}`,
            letterSpacing: "-.84px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */]["2xl"]}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].xl}`,
            letterSpacing: "-.72px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.Title]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].xl}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].lg}`,
            letterSpacing: "-.4px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].lg}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].md}`,
            letterSpacing: "-.32x",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].md}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].sm}`,
            letterSpacing: "-.28px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.Body]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Medium}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].xl}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].lg}`,
            letterSpacing: "-.08px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Medium}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].lg}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].md}`,
            letterSpacing: "-.07px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Medium}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].md}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].sm}`,
            letterSpacing: "-.06px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.ExtraSmall]: {
            fontFamily: fontFamilies.main,
            fontWeight: `${FONT_WEIGHTS.main.Medium}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].sm}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */]["xs"]}`,
            letterSpacing: `${LETTER_SPACING["Lightspark" /* Lightspark */]["tight-low"]}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.BodyStrong]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.SemiBold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].xl}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].lg}`,
            letterSpacing: "-.08px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.SemiBold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].lg}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].md}`,
            letterSpacing: "-.07px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.SemiBold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].md}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].sm}`,
            letterSpacing: "-.06px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.ExtraSmall]: {
            fontFamily: fontFamilies.main,
            fontWeight: `${FONT_WEIGHTS.main.SemiBold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].sm}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */]["xs"]}`,
            letterSpacing: `${LETTER_SPACING["Lightspark" /* Lightspark */]["tight-low"]}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.Label]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Medium}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].md}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].sm}`,
            letterSpacing: "-.07px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Medium}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].xs}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].xs}`,
            letterSpacing: "-.06px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Medium}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */]["2xs"]}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */]["2xs"]}`,
            letterSpacing: "-.05px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.LabelModerate]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.SemiBold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].md}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].sm}`,
            letterSpacing: "-.07px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.SemiBold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].xs}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].xs}`,
            letterSpacing: "-.06px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.SemiBold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */]["2xs"]}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */]["2xs"]}`,
            letterSpacing: "-.05px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.LabelStrong]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].md}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].sm}`,
            letterSpacing: "-.07px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].xs}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].xs}`,
            letterSpacing: "-.06px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */]["2xs"]}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */]["2xs"]}`,
            letterSpacing: "-.05px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.Overline]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].lg}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].md}`,
            letterSpacing: "1.92px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.uppercase}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].md}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].sm}`,
            letterSpacing: "1.68px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.uppercase}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].xs}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].xs}`,
            letterSpacing: "1.44px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.uppercase}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.Code]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.code}`,
            fontWeight: `${FONT_WEIGHTS.code.Regular}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].xl}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].lg}`,
            letterSpacing: `${LETTER_SPACING["Lightspark" /* Lightspark */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.code}`,
            fontWeight: `${FONT_WEIGHTS.code.Regular}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].lg}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].md}`,
            letterSpacing: `${LETTER_SPACING["Lightspark" /* Lightspark */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.code}`,
            fontWeight: `${FONT_WEIGHTS.code.Regular}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].md}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].sm}`,
            letterSpacing: `${LETTER_SPACING["Lightspark" /* Lightspark */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.CodeStrong]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.code}`,
            fontWeight: `${FONT_WEIGHTS.code.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].lg}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].md}`,
            letterSpacing: `${LETTER_SPACING["Lightspark" /* Lightspark */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.code}`,
            fontWeight: `${FONT_WEIGHTS.code.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].md}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].sm}`,
            letterSpacing: `${LETTER_SPACING["Lightspark" /* Lightspark */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.code}`,
            fontWeight: `${FONT_WEIGHTS.code.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].xs}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].xs}`,
            letterSpacing: `${LETTER_SPACING["Lightspark" /* Lightspark */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        }
      },
      Desktop: {
        [TypographyType.Display]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */]["7xl"]}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */]["6xl"]}`,
            letterSpacing: "-2.56px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */]["6xl"]}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */]["5xl"]}`,
            letterSpacing: "-1.92px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */]["5xl"]}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */]["4xl"]}`,
            letterSpacing: "-1.44px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.Headline]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */]["4xl"]}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */]["3xl"]}`,
            letterSpacing: "-.96px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */]["3xl"]}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */]["2xl"]}`,
            letterSpacing: "-.84px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */]["2xl"]}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].xl}`,
            letterSpacing: "-.72px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.Title]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].xl}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].lg}`,
            letterSpacing: "-.4px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].lg}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].md}`,
            letterSpacing: "-.32x",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].md}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].sm}`,
            letterSpacing: "-.28px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.Body]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Medium}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].xl}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].lg}`,
            letterSpacing: "-.08px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Medium}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].lg}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].md}`,
            letterSpacing: "-.07px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Medium}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].md}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].sm}`,
            letterSpacing: "-.06px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.ExtraSmall]: {
            fontFamily: fontFamilies.main,
            fontWeight: `${FONT_WEIGHTS.main.Medium}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].sm}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */]["xs"]}`,
            letterSpacing: `${LETTER_SPACING["Lightspark" /* Lightspark */]["tight-low"]}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.BodyStrong]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.SemiBold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].xl}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].lg}`,
            letterSpacing: "-.08px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.SemiBold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].lg}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].md}`,
            letterSpacing: "-.07px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.SemiBold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].md}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].sm}`,
            letterSpacing: "-.06px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.ExtraSmall]: {
            fontFamily: fontFamilies.main,
            fontWeight: `${FONT_WEIGHTS.main.SemiBold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].sm}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */]["xs"]}`,
            letterSpacing: `${LETTER_SPACING["Lightspark" /* Lightspark */]["tight-low"]}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.Label]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Medium}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].md}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].sm}`,
            letterSpacing: "-.07px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Medium}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].xs}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].xs}`,
            letterSpacing: "-.06px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Medium}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */]["2xs"]}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */]["2xs"]}`,
            letterSpacing: "-.05px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.LabelModerate]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.SemiBold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].md}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].sm}`,
            letterSpacing: "-.07px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.SemiBold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].xs}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].xs}`,
            letterSpacing: "-.06px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.SemiBold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */]["2xs"]}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */]["2xs"]}`,
            letterSpacing: "-.05px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.LabelStrong]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].md}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].sm}`,
            letterSpacing: "-.07px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].xs}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].xs}`,
            letterSpacing: "-.06px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */]["2xs"]}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */]["2xs"]}`,
            letterSpacing: "-.05px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.Overline]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].lg}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].md}`,
            letterSpacing: "1.92px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.uppercase}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].md}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].sm}`,
            letterSpacing: "1.68px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.uppercase}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].xs}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].xs}`,
            letterSpacing: "1.44px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.uppercase}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.Code]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.code}`,
            fontWeight: `${FONT_WEIGHTS.code.Regular}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].xl}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].lg}`,
            letterSpacing: `${LETTER_SPACING["Lightspark" /* Lightspark */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.code}`,
            fontWeight: `${FONT_WEIGHTS.code.Regular}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].lg}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].md}`,
            letterSpacing: `${LETTER_SPACING["Lightspark" /* Lightspark */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.code}`,
            fontWeight: `${FONT_WEIGHTS.code.Regular}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].md}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].sm}`,
            letterSpacing: `${LETTER_SPACING["Lightspark" /* Lightspark */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.CodeStrong]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.code}`,
            fontWeight: `${FONT_WEIGHTS.code.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].lg}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].md}`,
            letterSpacing: `${LETTER_SPACING["Lightspark" /* Lightspark */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.code}`,
            fontWeight: `${FONT_WEIGHTS.code.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].md}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].sm}`,
            letterSpacing: `${LETTER_SPACING["Lightspark" /* Lightspark */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.code}`,
            fontWeight: `${FONT_WEIGHTS.code.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].xs}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].xs}`,
            letterSpacing: `${LETTER_SPACING["Lightspark" /* Lightspark */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        }
      }
    },
    ["LightsparkDocs" /* LightsparkDocs */]: {
      Mobile: {
        [TypographyType.Display]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */]["7xl"]}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */]["6xl"]}`,
            letterSpacing: "-2.56px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */]["6xl"]}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */]["5xl"]}`,
            letterSpacing: "-1.92px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */]["5xl"]}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */]["4xl"]}`,
            letterSpacing: "-1.44px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.Headline]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */]["4xl"]}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */]["3xl"]}`,
            letterSpacing: "-.96px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */]["3xl"]}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */]["2xl"]}`,
            letterSpacing: "-.84px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */]["2xl"]}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].xl}`,
            letterSpacing: "-.72px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.ExtraSmall]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].xl}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].lg}`,
            letterSpacing: "-.60px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.Title]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].xl}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].lg}`,
            letterSpacing: "-.4px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].lg}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].md}`,
            letterSpacing: "-.32x",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].md}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].sm}`,
            letterSpacing: "-.28px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.Body]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Medium}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].xl}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].lg}`,
            letterSpacing: "-.08px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Medium}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].lg}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].md}`,
            letterSpacing: "-.07px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Medium}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].md}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].sm}`,
            letterSpacing: "-.06px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.ExtraSmall]: {
            fontFamily: fontFamilies.main,
            fontWeight: `${FONT_WEIGHTS.main.Medium}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].sm}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */]["xs"]}`,
            letterSpacing: `${LETTER_SPACING["Lightspark" /* Lightspark */]["tight-low"]}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.BodyStrong]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].xl}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].lg}`,
            letterSpacing: "-.08px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].lg}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].md}`,
            letterSpacing: "-.07px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].md}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].sm}`,
            letterSpacing: "-.06px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.Label]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Medium}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].md}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].sm}`,
            letterSpacing: "-.07px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Medium}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].xs}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].xs}`,
            letterSpacing: "-.06px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Medium}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */]["2xs"]}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */]["2xs"]}`,
            letterSpacing: "-.05px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.LabelModerate]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.SemiBold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].md}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].sm}`,
            letterSpacing: "-.07px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.SemiBold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].xs}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].xs}`,
            letterSpacing: "-.06px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.SemiBold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */]["2xs"]}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */]["2xs"]}`,
            letterSpacing: "-.05px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.LabelStrong]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].md}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].sm}`,
            letterSpacing: "-.07px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].xs}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].xs}`,
            letterSpacing: "-.06px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */]["2xs"]}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */]["2xs"]}`,
            letterSpacing: "-.05px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.Overline]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].lg}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].md}`,
            letterSpacing: "1.92px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.uppercase}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].md}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].sm}`,
            letterSpacing: "1.68px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.uppercase}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].xs}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].xs}`,
            letterSpacing: "1.44px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.uppercase}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.Code]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.code}`,
            fontWeight: `${FONT_WEIGHTS.code.Regular}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].xl}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].lg}`,
            letterSpacing: `${LETTER_SPACING["Lightspark" /* Lightspark */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.code}`,
            fontWeight: `${FONT_WEIGHTS.code.Regular}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].lg}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].md}`,
            letterSpacing: `${LETTER_SPACING["Lightspark" /* Lightspark */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.code}`,
            fontWeight: `${FONT_WEIGHTS.code.Regular}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].md}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].sm}`,
            letterSpacing: `${LETTER_SPACING["Lightspark" /* Lightspark */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.CodeStrong]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.code}`,
            fontWeight: `${FONT_WEIGHTS.code.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].lg}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].md}`,
            letterSpacing: `${LETTER_SPACING["Lightspark" /* Lightspark */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.code}`,
            fontWeight: `${FONT_WEIGHTS.code.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].md}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].sm}`,
            letterSpacing: `${LETTER_SPACING["Lightspark" /* Lightspark */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.code}`,
            fontWeight: `${FONT_WEIGHTS.code.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].xs}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].xs}`,
            letterSpacing: `${LETTER_SPACING["Lightspark" /* Lightspark */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        }
      },
      Desktop: {
        [TypographyType.Display]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */]["7xl"]}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */]["6xl"]}`,
            letterSpacing: "-2.56px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */]["6xl"]}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */]["5xl"]}`,
            letterSpacing: "-1.92px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */]["5xl"]}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */]["4xl"]}`,
            letterSpacing: "-1.44px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.Headline]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */]["4xl"]}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */]["3xl"]}`,
            letterSpacing: "-.96px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */]["3xl"]}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */]["2xl"]}`,
            letterSpacing: "-.84px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */]["2xl"]}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].xl}`,
            letterSpacing: "-.72px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.ExtraSmall]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */]["xl"]}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].lg}`,
            letterSpacing: "-.60px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.Title]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].xl}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].lg}`,
            letterSpacing: "-.4px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].lg}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].md}`,
            letterSpacing: "-.32x",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].md}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].sm}`,
            letterSpacing: "-.28px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.Body]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Medium}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].xl}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].lg}`,
            letterSpacing: "-.08px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Medium}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].lg}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].md}`,
            letterSpacing: "-.07px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Medium}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].md}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].sm}`,
            letterSpacing: "-.06px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.ExtraSmall]: {
            fontFamily: fontFamilies.main,
            fontWeight: `${FONT_WEIGHTS.main.Medium}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].sm}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */]["xs"]}`,
            letterSpacing: `${LETTER_SPACING["Lightspark" /* Lightspark */]["tight-low"]}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.BodyStrong]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].xl}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].lg}`,
            letterSpacing: "-.08px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].lg}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].md}`,
            letterSpacing: "-.07px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].md}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].sm}`,
            letterSpacing: "-.06px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.Label]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Medium}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].md}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].sm}`,
            letterSpacing: "-.07px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Medium}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].xs}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].xs}`,
            letterSpacing: "-.06px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Medium}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */]["2xs"]}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */]["2xs"]}`,
            letterSpacing: "-.05px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.LabelModerate]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.SemiBold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].md}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].sm}`,
            letterSpacing: "-.07px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.SemiBold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].xs}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].xs}`,
            letterSpacing: "-.06px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.SemiBold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */]["2xs"]}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */]["2xs"]}`,
            letterSpacing: "-.05px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.LabelStrong]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].md}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].sm}`,
            letterSpacing: "-.07px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].xs}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].xs}`,
            letterSpacing: "-.06px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */]["2xs"]}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */]["2xs"]}`,
            letterSpacing: "-.05px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.Overline]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].lg}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].md}`,
            letterSpacing: "1.92px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.uppercase}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].md}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].sm}`,
            letterSpacing: "1.68px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.uppercase}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].xs}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].xs}`,
            letterSpacing: "1.44px",
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.uppercase}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.Code]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.code}`,
            fontWeight: `${FONT_WEIGHTS.code.Regular}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].xl}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].lg}`,
            letterSpacing: `${LETTER_SPACING["Lightspark" /* Lightspark */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.code}`,
            fontWeight: `${FONT_WEIGHTS.code.Regular}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].lg}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].md}`,
            letterSpacing: `${LETTER_SPACING["Lightspark" /* Lightspark */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.code}`,
            fontWeight: `${FONT_WEIGHTS.code.Regular}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].md}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].sm}`,
            letterSpacing: `${LETTER_SPACING["Lightspark" /* Lightspark */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.CodeStrong]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.code}`,
            fontWeight: `${FONT_WEIGHTS.code.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].lg}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].md}`,
            letterSpacing: `${LETTER_SPACING["Lightspark" /* Lightspark */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.code}`,
            fontWeight: `${FONT_WEIGHTS.code.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].md}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].sm}`,
            letterSpacing: `${LETTER_SPACING["Lightspark" /* Lightspark */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.code}`,
            fontWeight: `${FONT_WEIGHTS.code.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Lightspark" /* Lightspark */].xs}`,
            fontSize: `${FONT_SIZE["Lightspark" /* Lightspark */].xs}`,
            letterSpacing: `${LETTER_SPACING["Lightspark" /* Lightspark */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        }
      }
    },
    ["UmaAuthSdk" /* UmaAuthSdk */]: {
      Mobile: {
        [TypographyType.Display]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */]["5xl"]}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */]["6xl"]}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].tight}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */]["4xl"]}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */]["5xl"]}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].tight}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */]["3xl"]}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */]["4xl"]}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].tight}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.Headline]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */]["2xl"]}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */]["3xl"]}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].tight}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[16]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */].xl}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */]["2xl"]}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].tight}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[16]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */].lg}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */].xl}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].tight}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[16]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.ExtraSmall]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */].md}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */].lg}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].tight}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[16]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.Title]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */].md}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */].lg}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */].sm}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */].md}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */].xs}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */].sm}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.Body]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Medium}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */].sm}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */].md}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Medium}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */].sm}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */].sm}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Medium}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */].sm}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */].xs}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.BodyStrong]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */].sm}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */].md}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.SemiBold}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */].sm}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */].sm}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.SemiBold}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */].sm}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */].xs}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.Label]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Medium}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */].xs}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */].sm}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Medium}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */]["2xs"]}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */].xs}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Medium}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */]["2xs"]}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */]["2xs"]}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.LabelModerate]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.SemiBold}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */].xs}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */].sm}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.SemiBold}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */]["2xs"]}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */].xs}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.SemiBold}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */]["2xs"]}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */]["2xs"]}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.LabelStrong]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */].xs}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */].sm}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */]["2xs"]}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */].xs}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */]["2xs"]}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */]["2xs"]}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.Overline]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */].sm}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */].md}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].loose}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.uppercase}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */].xs}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */].sm}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].loose}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.uppercase}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */]["2xs"]}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */].xs}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].loose}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.uppercase}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.Code]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.code}`,
            fontWeight: `${FONT_WEIGHTS.code.Regular}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */].sm}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */].md}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.code}`,
            fontWeight: `${FONT_WEIGHTS.code.Regular}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */].sm}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */].sm}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.code}`,
            fontWeight: `${FONT_WEIGHTS.code.Regular}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */].xs}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */].xs}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.CodeStrong]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.code}`,
            fontWeight: `${FONT_WEIGHTS.code.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */].sm}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */].md}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.code}`,
            fontWeight: `${FONT_WEIGHTS.code.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */].sm}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */].sm}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.code}`,
            fontWeight: `${FONT_WEIGHTS.code.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */].sm}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */].xs}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        }
      },
      Desktop: {
        [TypographyType.Display]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */]["5xl"]}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */]["6xl"]}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].tight}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */]["4xl"]}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */]["5xl"]}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].tight}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */]["3xl"]}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */]["4xl"]}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].tight}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.Headline]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */]["2xl"]}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */]["3xl"]}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].tight}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[16]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */].xl}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */]["2xl"]}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].tight}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[16]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */].lg}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */].xl}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].tight}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[16]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.ExtraSmall]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */].md}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */].lg}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].tight}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[16]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.Title]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */].md}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */].lg}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */].sm}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */].md}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */].xs}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */].sm}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.Body]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Medium}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */].sm}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */].md}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Medium}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */].xs}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */].sm}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Medium}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */].sm}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */].xs}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.BodyStrong]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */].sm}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */].md}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.SemiBold}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */].sm}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */].sm}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.SemiBold}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */].sm}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */].xs}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.Label]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Medium}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */].xs}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */].sm}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Medium}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */]["2xs"]}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */].xs}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Medium}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */]["2xs"]}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */]["2xs"]}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.LabelModerate]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.SemiBold}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */].xs}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */].sm}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.SemiBold}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */]["2xs"]}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */].xs}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.SemiBold}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */]["2xs"]}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */]["2xs"]}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.LabelStrong]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */].xs}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */].sm}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */]["2xs"]}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */].xs}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */]["2xs"]}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */]["2xs"]}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.Overline]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */].sm}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */].md}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].loose}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.uppercase}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */].xs}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */].sm}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].loose}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.uppercase}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */]["2xs"]}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */].xs}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].loose}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.uppercase}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.Code]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.code}`,
            fontWeight: `${FONT_WEIGHTS.code.Regular}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */].sm}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */].md}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.code}`,
            fontWeight: `${FONT_WEIGHTS.code.Regular}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */].sm}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */].sm}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.code}`,
            fontWeight: `${FONT_WEIGHTS.code.Regular}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */].xs}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */].xs}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.CodeStrong]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.code}`,
            fontWeight: `${FONT_WEIGHTS.code.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */].sm}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */].md}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.code}`,
            fontWeight: `${FONT_WEIGHTS.code.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */].sm}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */].sm}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.code}`,
            fontWeight: `${FONT_WEIGHTS.code.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmaAuthSdk" /* UmaAuthSdk */].sm}`,
            fontSize: `${FONT_SIZE["UmaAuthSdk" /* UmaAuthSdk */].xs}`,
            letterSpacing: `${LETTER_SPACING["UmaAuthSdk" /* UmaAuthSdk */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        }
      }
    },
    ["UmameDocs" /* UmameDocs */]: {
      Mobile: {
        [TypographyType.Display]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */]["5xl"]}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */]["6xl"]}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].tight}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */]["4xl"]}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */]["5xl"]}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].tight}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */]["3xl"]}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */]["4xl"]}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].tight}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.Headline]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */]["2xl"]}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */]["3xl"]}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].tight}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[16]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */].xl}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */]["2xl"]}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].tight}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[16]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */].lg}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */].xl}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].tight}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[16]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.ExtraSmall]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */].md}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */].lg}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].tight}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[16]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.Title]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */].md}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */].lg}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */].sm}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */].md}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */].xs}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */].sm}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.Body]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.SemiBold}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */].sm}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */].md}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Medium}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */].sm}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */].sm}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Medium}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */].sm}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */].xs}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.BodyStrong]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */].sm}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */].md}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.SemiBold}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */].sm}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */].sm}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.SemiBold}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */].sm}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */].xs}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.Label]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.SemiBold}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */].xs}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */].sm}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.SemiBold}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */]["2xs"]}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */].xs}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.SemiBold}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */]["2xs"]}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */]["2xs"]}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.LabelModerate]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */].xs}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */].sm}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */]["2xs"]}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */].xs}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */]["2xs"]}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */]["2xs"]}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.LabelStrong]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */].xs}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */].sm}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */]["2xs"]}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */].xs}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */]["2xs"]}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */]["2xs"]}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.Overline]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */].sm}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */].md}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].loose}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.uppercase}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */].xs}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */].sm}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].loose}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.uppercase}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */]["2xs"]}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */].xs}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].loose}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.uppercase}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.Code]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.code}`,
            fontWeight: `${FONT_WEIGHTS.code.Regular}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */].sm}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */].md}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.code}`,
            fontWeight: `${FONT_WEIGHTS.code.Regular}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */].sm}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */].sm}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.code}`,
            fontWeight: `${FONT_WEIGHTS.code.Regular}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */].xs}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */].xs}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.CodeStrong]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.code}`,
            fontWeight: `${FONT_WEIGHTS.code.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */].sm}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */].md}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.code}`,
            fontWeight: `${FONT_WEIGHTS.code.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */].sm}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */].sm}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.code}`,
            fontWeight: `${FONT_WEIGHTS.code.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */].sm}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */].xs}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        }
      },
      Desktop: {
        [TypographyType.Display]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */]["5xl"]}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */]["6xl"]}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].tight}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */]["4xl"]}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */]["5xl"]}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].tight}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */]["3xl"]}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */]["4xl"]}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].tight}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.Headline]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */]["2xl"]}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */]["2xl"]}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].tight}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[16]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */].lg}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */].xl}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].tight}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[16]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */].lg}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */].lg}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].tight}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[16]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.ExtraSmall]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */].md}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */].lg}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].tight}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[16]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.Title]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */].md}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */].lg}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */].sm}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */].md}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */].xs}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */].sm}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.Body]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.SemiBold}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */].sm}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */].md}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Medium}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */].sm}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */].sm}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Medium}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */].sm}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */].xs}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.BodyStrong]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */].sm}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */].md}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.SemiBold}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */].sm}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */].sm}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.SemiBold}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */].sm}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */].xs}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.Label]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.SemiBold}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */].xs}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */].sm}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.SemiBold}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */]["2xs"]}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */].xs}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.SemiBold}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */]["2xs"]}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */]["2xs"]}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.LabelModerate]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */].xs}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */].sm}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */]["2xs"]}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */].xs}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */]["2xs"]}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */]["2xs"]}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.LabelStrong]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */].xs}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */].sm}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */]["2xs"]}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */].xs}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */]["2xs"]}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */]["2xs"]}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.Overline]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */].sm}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */].md}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].loose}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.uppercase}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */].xs}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */].sm}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].loose}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.uppercase}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */]["2xs"]}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */].xs}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].loose}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.uppercase}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.Code]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.code}`,
            fontWeight: `${FONT_WEIGHTS.code.Regular}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */].sm}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */].md}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.code}`,
            fontWeight: `${FONT_WEIGHTS.code.Regular}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */].sm}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */].sm}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.code}`,
            fontWeight: `${FONT_WEIGHTS.code.Regular}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */].xs}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */].xs}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.CodeStrong]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.code}`,
            fontWeight: `${FONT_WEIGHTS.code.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */].sm}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */].md}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.code}`,
            fontWeight: `${FONT_WEIGHTS.code.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */].sm}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */].sm}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.code}`,
            fontWeight: `${FONT_WEIGHTS.code.Bold}`,
            lineHeight: `${LINE_HEIGHTS["UmameDocs" /* UmameDocs */].sm}`,
            fontSize: `${FONT_SIZE["UmameDocs" /* UmameDocs */].xs}`,
            letterSpacing: `${LETTER_SPACING["UmameDocs" /* UmameDocs */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING.default}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        }
      }
    },
    ["Bridge" /* Bridge */]: {
      Mobile: {
        [TypographyType.Display]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Bridge" /* Bridge */]["8xl"]}`,
            fontSize: `${FONT_SIZE["Bridge" /* Bridge */]["7xl"]}`,
            letterSpacing: `${LETTER_SPACING["Bridge" /* Bridge */].tight}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Bridge" /* Bridge */]["7xl"]}`,
            fontSize: `${FONT_SIZE["Bridge" /* Bridge */]["6xl"]}`,
            letterSpacing: `${LETTER_SPACING["Bridge" /* Bridge */].tight}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Bridge" /* Bridge */]["6xl"]}`,
            fontSize: `${FONT_SIZE["Bridge" /* Bridge */]["5xl"]}`,
            letterSpacing: `${LETTER_SPACING["Bridge" /* Bridge */].tight}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.Headline]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Bridge" /* Bridge */]["5xl"]}`,
            fontSize: `${FONT_SIZE["Bridge" /* Bridge */]["4xl"]}`,
            letterSpacing: `${LETTER_SPACING["Bridge" /* Bridge */].tight}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Bridge" /* Bridge */]["4xl"]}`,
            fontSize: `${FONT_SIZE["Bridge" /* Bridge */]["3xl"]}`,
            letterSpacing: `${LETTER_SPACING["Bridge" /* Bridge */].tight}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Bridge" /* Bridge */]["3xl"]}`,
            fontSize: `${FONT_SIZE["Bridge" /* Bridge */]["2xl"]}`,
            letterSpacing: `${LETTER_SPACING["Bridge" /* Bridge */].tight}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.Title]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Bridge" /* Bridge */]["2xl"]}`,
            fontSize: `${FONT_SIZE["Bridge" /* Bridge */]["xl"]}`,
            letterSpacing: `${LETTER_SPACING["Bridge" /* Bridge */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Bridge" /* Bridge */]["xl"]}`,
            fontSize: `${FONT_SIZE["Bridge" /* Bridge */]["lg"]}`,
            letterSpacing: `${LETTER_SPACING["Bridge" /* Bridge */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Bridge" /* Bridge */]["md"]}`,
            fontSize: `${FONT_SIZE["Bridge" /* Bridge */]["md"]}`,
            letterSpacing: `${LETTER_SPACING["Bridge" /* Bridge */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.Body]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Medium}`,
            lineHeight: `${LINE_HEIGHTS["Bridge" /* Bridge */]["xl"]}`,
            fontSize: `${FONT_SIZE["Bridge" /* Bridge */]["lg"]}`,
            letterSpacing: `${LETTER_SPACING["Bridge" /* Bridge */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Medium}`,
            lineHeight: `${LINE_HEIGHTS["Bridge" /* Bridge */]["lg"]}`,
            fontSize: `${FONT_SIZE["Bridge" /* Bridge */]["md"]}`,
            letterSpacing: `${LETTER_SPACING["Bridge" /* Bridge */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Medium}`,
            lineHeight: `${LINE_HEIGHTS["Bridge" /* Bridge */]["sm"]}`,
            fontSize: `${FONT_SIZE["Bridge" /* Bridge */]["xs"]}`,
            letterSpacing: `${LETTER_SPACING["Bridge" /* Bridge */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.Label]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Medium}`,
            lineHeight: `${LINE_HEIGHTS["Bridge" /* Bridge */]["md"]}`,
            fontSize: `${FONT_SIZE["Bridge" /* Bridge */]["md"]}`,
            letterSpacing: `${LETTER_SPACING["Bridge" /* Bridge */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Medium}`,
            lineHeight: `${LINE_HEIGHTS["Bridge" /* Bridge */]["xs"]}`,
            fontSize: `${FONT_SIZE["Bridge" /* Bridge */]["xs"]}`,
            letterSpacing: `${LETTER_SPACING["Bridge" /* Bridge */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Medium}`,
            lineHeight: `${LINE_HEIGHTS["Bridge" /* Bridge */]["xs"]}`,
            fontSize: `${FONT_SIZE["Bridge" /* Bridge */]["2xs"]}`,
            letterSpacing: `${LETTER_SPACING["Bridge" /* Bridge */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.LabelModerate]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.SemiBold}`,
            lineHeight: `${LINE_HEIGHTS["Bridge" /* Bridge */]["md"]}`,
            fontSize: `${FONT_SIZE["Bridge" /* Bridge */]["md"]}`,
            letterSpacing: `${LETTER_SPACING["Bridge" /* Bridge */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.SemiBold}`,
            lineHeight: `${LINE_HEIGHTS["Bridge" /* Bridge */]["xs"]}`,
            fontSize: `${FONT_SIZE["Bridge" /* Bridge */]["xs"]}`,
            letterSpacing: `${LETTER_SPACING["Bridge" /* Bridge */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.SemiBold}`,
            lineHeight: `${LINE_HEIGHTS["Bridge" /* Bridge */]["xs"]}`,
            fontSize: `${FONT_SIZE["Bridge" /* Bridge */]["2xs"]}`,
            letterSpacing: `${LETTER_SPACING["Bridge" /* Bridge */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.LabelStrong]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Bridge" /* Bridge */]["md"]}`,
            fontSize: `${FONT_SIZE["Bridge" /* Bridge */]["md"]}`,
            letterSpacing: `${LETTER_SPACING["Bridge" /* Bridge */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Bridge" /* Bridge */]["xs"]}`,
            fontSize: `${FONT_SIZE["Bridge" /* Bridge */]["xs"]}`,
            letterSpacing: `${LETTER_SPACING["Bridge" /* Bridge */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Bridge" /* Bridge */]["xs"]}`,
            fontSize: `${FONT_SIZE["Bridge" /* Bridge */]["2xs"]}`,
            letterSpacing: `${LETTER_SPACING["Bridge" /* Bridge */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        }
      },
      Desktop: {
        [TypographyType.Display]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Bridge" /* Bridge */]["8xl"]}`,
            fontSize: `${FONT_SIZE["Bridge" /* Bridge */]["7xl"]}`,
            letterSpacing: `${LETTER_SPACING["Bridge" /* Bridge */].tight}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Bridge" /* Bridge */]["7xl"]}`,
            fontSize: `${FONT_SIZE["Bridge" /* Bridge */]["6xl"]}`,
            letterSpacing: `${LETTER_SPACING["Bridge" /* Bridge */].tight}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Bridge" /* Bridge */]["6xl"]}`,
            fontSize: `${FONT_SIZE["Bridge" /* Bridge */]["5xl"]}`,
            letterSpacing: `${LETTER_SPACING["Bridge" /* Bridge */].tight}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.Headline]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Bridge" /* Bridge */]["5xl"]}`,
            fontSize: `${FONT_SIZE["Bridge" /* Bridge */]["4xl"]}`,
            letterSpacing: `${LETTER_SPACING["Bridge" /* Bridge */].tight}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Bridge" /* Bridge */]["4xl"]}`,
            fontSize: `${FONT_SIZE["Bridge" /* Bridge */]["3xl"]}`,
            letterSpacing: `${LETTER_SPACING["Bridge" /* Bridge */].tight}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Bridge" /* Bridge */]["3xl"]}`,
            fontSize: `${FONT_SIZE["Bridge" /* Bridge */]["2xl"]}`,
            letterSpacing: `${LETTER_SPACING["Bridge" /* Bridge */].tight}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.Title]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Bridge" /* Bridge */]["2xl"]}`,
            fontSize: `${FONT_SIZE["Bridge" /* Bridge */]["xl"]}`,
            letterSpacing: `${LETTER_SPACING["Bridge" /* Bridge */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Bridge" /* Bridge */]["xl"]}`,
            fontSize: `${FONT_SIZE["Bridge" /* Bridge */]["lg"]}`,
            letterSpacing: `${LETTER_SPACING["Bridge" /* Bridge */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Bridge" /* Bridge */]["md"]}`,
            fontSize: `${FONT_SIZE["Bridge" /* Bridge */]["md"]}`,
            letterSpacing: `${LETTER_SPACING["Bridge" /* Bridge */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.Body]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Medium}`,
            lineHeight: `${LINE_HEIGHTS["Bridge" /* Bridge */]["xl"]}`,
            fontSize: `${FONT_SIZE["Bridge" /* Bridge */]["lg"]}`,
            letterSpacing: `${LETTER_SPACING["Bridge" /* Bridge */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Medium}`,
            lineHeight: `${LINE_HEIGHTS["Bridge" /* Bridge */]["lg"]}`,
            fontSize: `${FONT_SIZE["Bridge" /* Bridge */]["md"]}`,
            letterSpacing: `${LETTER_SPACING["Bridge" /* Bridge */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Medium}`,
            lineHeight: `${LINE_HEIGHTS["Bridge" /* Bridge */]["sm"]}`,
            fontSize: `${FONT_SIZE["Bridge" /* Bridge */]["xs"]}`,
            letterSpacing: `${LETTER_SPACING["Bridge" /* Bridge */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.Label]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Medium}`,
            lineHeight: `${LINE_HEIGHTS["Bridge" /* Bridge */]["md"]}`,
            fontSize: `${FONT_SIZE["Bridge" /* Bridge */]["md"]}`,
            letterSpacing: `${LETTER_SPACING["Bridge" /* Bridge */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Medium}`,
            lineHeight: `${LINE_HEIGHTS["Bridge" /* Bridge */]["xs"]}`,
            fontSize: `${FONT_SIZE["Bridge" /* Bridge */]["xs"]}`,
            letterSpacing: `${LETTER_SPACING["Bridge" /* Bridge */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Medium}`,
            lineHeight: `${LINE_HEIGHTS["Bridge" /* Bridge */]["xs"]}`,
            fontSize: `${FONT_SIZE["Bridge" /* Bridge */]["2xs"]}`,
            letterSpacing: `${LETTER_SPACING["Bridge" /* Bridge */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.LabelModerate]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.SemiBold}`,
            lineHeight: `${LINE_HEIGHTS["Bridge" /* Bridge */]["md"]}`,
            fontSize: `${FONT_SIZE["Bridge" /* Bridge */]["md"]}`,
            letterSpacing: `${LETTER_SPACING["Bridge" /* Bridge */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.SemiBold}`,
            lineHeight: `${LINE_HEIGHTS["Bridge" /* Bridge */]["xs"]}`,
            fontSize: `${FONT_SIZE["Bridge" /* Bridge */]["xs"]}`,
            letterSpacing: `${LETTER_SPACING["Bridge" /* Bridge */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.SemiBold}`,
            lineHeight: `${LINE_HEIGHTS["Bridge" /* Bridge */]["xs"]}`,
            fontSize: `${FONT_SIZE["Bridge" /* Bridge */]["2xs"]}`,
            letterSpacing: `${LETTER_SPACING["Bridge" /* Bridge */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        },
        [TypographyType.LabelStrong]: {
          [TokenSize.Large]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Bridge" /* Bridge */]["md"]}`,
            fontSize: `${FONT_SIZE["Bridge" /* Bridge */]["md"]}`,
            letterSpacing: `${LETTER_SPACING["Bridge" /* Bridge */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Medium]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Bridge" /* Bridge */]["xs"]}`,
            fontSize: `${FONT_SIZE["Bridge" /* Bridge */]["xs"]}`,
            letterSpacing: `${LETTER_SPACING["Bridge" /* Bridge */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          },
          [TokenSize.Small]: {
            fontFamily: `${fontFamilies.main}`,
            fontWeight: `${FONT_WEIGHTS.main.Bold}`,
            lineHeight: `${LINE_HEIGHTS["Bridge" /* Bridge */]["xs"]}`,
            fontSize: `${FONT_SIZE["Bridge" /* Bridge */]["2xs"]}`,
            letterSpacing: `${LETTER_SPACING["Bridge" /* Bridge */].normal}`,
            paragraphSpacing: `${PARAGRAPH_SPACING[0]}`,
            paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
            textCase: `${TEXT_CASE.none}`,
            textDecoration: `${TEXT_DECORATION.none}`
          }
        }
      }
    }
  };
}
function getTypography(typographyGroup, customFontFamilies) {
  const fontFamilies = customFontFamilies != null ? customFontFamilies : FONT_FAMILIES;
  return {
    group: typographyGroup,
    fontFamilies,
    lineHeights: LINE_HEIGHTS[typographyGroup],
    fontWeights: FONT_WEIGHTS,
    fontSize: FONT_SIZE[typographyGroup],
    letterSpacing: LETTER_SPACING[typographyGroup],
    textCase: TEXT_CASE,
    textDecoration: TEXT_DECORATION,
    paragraphIndent: PARAGRAPH_INDENT,
    paragraphSpacing: PARAGRAPH_SPACING,
    types: getTypographyTypes(fontFamilies)[typographyGroup]
  };
}
function mayTokensToStyles(tokens) {
  return Object.entries(tokens).map((entry) => {
    switch (entry[0]) {
      case "fontFamily":
        return `font-family: ${entry[1]};`;
      case "fontWeight":
        return `font-weight: ${entry[1]};`;
      case "lineHeight":
        return `line-height: ${entry[1]};`;
      case "fontSize":
        return `font-size: ${entry[1]};`;
      case "letterSpacing":
        return `letter-spacing: ${entry[1]};`;
      case "textDecoration":
        return `text-decoration: ${entry[1]};`;
      case "paragraphSpacing":
        return "";
      case "paragraphIndent":
        return `text-indent: ${entry[1]};`;
      case "textCase":
        return `text-transform: ${entry[1]};`;
      default:
        return `${entry[0]}: ${entry[1]};`;
    }
  }).join("");
}
var defaultTokens = {
  fontFamily: FONT_FAMILIES.main,
  fontWeight: `${FONT_WEIGHTS.main.Medium}`,
  lineHeight: LINE_HEIGHTS["Lightspark" /* Lightspark */].sm,
  fontSize: FONT_SIZE["Lightspark" /* Lightspark */].sm,
  letterSpacing: LETTER_SPACING["Lightspark" /* Lightspark */].normal,
  paragraphSpacing: PARAGRAPH_SPACING.default,
  paragraphIndent: `${PARAGRAPH_INDENT[0]}`,
  textCase: TEXT_CASE.none,
  textDecoration: TEXT_DECORATION.none
};
var getTypographyString = (theme, typographyType, size) => {
  const mobileTokenGroups = theme.typography.types["Mobile"];
  const desktopTokenGroups = theme.typography.types["Desktop"];
  const mobileTokenSizes = mobileTokenGroups[typographyType];
  const desktopTokenSizes = desktopTokenGroups[typographyType];
  let mobileTokens = mobileTokenSizes == null ? void 0 : mobileTokenSizes[size];
  let desktopTokens = desktopTokenSizes == null ? void 0 : desktopTokenSizes[size];
  if (!mobileTokens || !desktopTokens) {
    if (!mobileTokenSizes || !desktopTokenSizes) {
      console.error(
        `Attempted to use a typography type "${typographyType}" that does not exist in the current theme. Falling back to default tokens.`
      );
    } else {
      console.error(
        `Attempted to use a typography size "${size}" that does not exist for typography type "${typographyType}" in the current theme. Falling back to default tokens.`
      );
    }
    mobileTokens = defaultTokens;
    desktopTokens = defaultTokens;
  }
  const typographyStr = `
    ${mayTokensToStyles(desktopTokens)}
    ${bp.sm(mayTokensToStyles(mobileTokens))}
  `;
  return typographyStr;
};
function getLineHeightForTypographyType(type, size, theme) {
  const desktopTokenGroups = theme.typography.types["Desktop"];
  const desktopTokenSizes = desktopTokenGroups[type];
  if (!desktopTokenSizes) {
    console.error(
      `getLineHeightForTypographyType: Attempted to use a typography type "${type}" that does not exist in the current theme. Falling back to default tokens.`
    );
    return defaultTokens.lineHeight;
  }
  const desktopTokens = desktopTokenSizes[size];
  if (!desktopTokens) {
    console.error(
      `getLineHeightForTypographyType: Attempted to use a typography size "${size}" that does not exist for typography type "${type}" in the current theme. Falling back to default tokens.`
    );
    return defaultTokens.lineHeight;
  }
  return desktopTokens.lineHeight;
}
function getLineHeightNumberForTypographyType(type, size, theme) {
  const lineHeight = getLineHeightForTypographyType(type, size, theme);
  return parseFloat(lineHeight);
}

export {
  TypographyGroup,
  lineHeightKeys,
  getLineHeightFromKey,
  TokenSize,
  TypographyType,
  getTypography,
  getTypographyString,
  getLineHeightForTypographyType,
  getLineHeightNumberForTypographyType
};
